export default {
  DATE_ROW_COUNT: 6,
  DATE_COL_COUNT: 7
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-calendar/es/date/DateConstants.js
// module id = 210
// module chunks = 0 1